import Header from "./component/Header/Header";
import Main from "./component/main/Main";

function App() {
  return (
    <div >
      <Header/>
      <Main/>
    </div>
  );
}

export default App;
